export enum ILocationType {
    Unknown = 0,
    Branch = 1,
    ATM = 2
}